import styled from 'styled-components'

import { ChevronFlip as DefaultChevronFlip } from '@subaio/components'

import { helpers } from 'styles'

export const ChevronFlip = styled(DefaultChevronFlip)`
	color: ${helpers.color.primary};
`
